import { Box, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import TrueFocus from "../../../components/animation/trueFocus/trueFocus";
import ButtonComponent from "../../../components/form/buttonComponent";
import { useCallback } from "react";
import TextType from "../../../components/animation/textType/textType";
import { useNavigate } from "react-router-dom";

const HeroDescription = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    const contact = useCallback(() => {
        navigate('/contact-us');
    }, []);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='start'
                spacing={{xs: 2, md: 3, lg: 4}}
                pr={{xs: 0, md: 10}}
                pt={{xs: 3, md: 0}}
            >
                <Box
                    sx={{
                        minHeight: {xs: 75, md: 125, lg: 150}
                    }}
                >
                    <TextType 
                        text={[t(`hero.title.ai`), t(`hero.title.games`), t(`hero.title.digital`)]}
                        typingSpeed={80}
                        deletingSpeed={30}
                        pauseDuration={750}
                        showCursor={false}
                        cursorCharacter="|"
                        color={theme.palette.text.primary}
                        fontWeight={900}
                        fontSize={{xs: 30, md: 45, lg: 60}}
                    />
                </Box>

                <TrueFocus 
                    sentence={`${t(`hero.description.ai`)} ${t(`hero.description.games`)} ${t(`hero.description.digital`)}`}
                    prefix={
                        <Typography
                            fontWeight={500}
                            fontSize={{xs: 14, md: 16, lg: 24}}
                            textAlign='left'
                            lineHeight={1.25}
                            color={theme.palette.text.secondary}
                        >
                            {t(`hero.description.prefix`)}
                        </Typography>
                    }
                    blurAmount={3}
                    borderColor={theme.palette.primary.main}
                    animationDuration={1}
                    pauseBetweenAnimations={2}
                    fontSize={{xs: 14, md: 16, lg: 24}}
                    fontWeight={500}
                />

                <ButtonComponent 
                    label={t(`hero.contact`)}
                    onClick={contact}
                />
            </Stack>
        </>
    );
}

export default HeroDescription;